export const seo = {
  title: 'Refer a friend | Gousto',
  meta: [
    {
      name: 'og:description',
      content: 'Get 65% off your first box plus 25% off other boxes in your first two months',
    },
    {
      name: 'og:type',
      content: 'website',
    },
    {
      name: 'og:url',
      content: 'https://www.gousto.co.uk/raf/',
    },
  ],
}
